import React from "react";
import { connect } from "react-redux";

import {
  getSchoolsHavingBasketItems,
  isBasketItemsValid,
  isBasketItemsValidating,
  isCheckoutWindowOpen,
  getCheckoutSchoolID
} from "state/school_money/selectors";

import Preloader from "components/school_money/Preloader";
import ScrollableContainer from "components/ScrollableContainer";
import List from "components/List";
import Card from "components/Card";
import BasketItemsIssuesModal from "components/school_money/basket/BasketItemsIssuesModal";
import SchoolBasket from "components/school_money/basket/SchoolBasket";
import CheckoutWindow from "components/school_money/basket/checkout/CheckoutWindow";

import "./BasketPage.css";

class BasketPage extends React.Component {
  
  isReady = () => {
    return !this.props.isValidating;
  }
  
  render() {
    const { isValid, schoolIDs, isCheckoutWindowOpen, checkoutSchoolID } = this.props;
    return (
      <Preloader isPageReady={this.isReady}>
        <div className="basket-page">
          <div className="page-header">
            <h1 className="page-header__title">Basket</h1>
          </div>
          {
            isValid ?
            <ScrollableContainer className="basket-school-list">
              <List placeholder={<Placeholder />}>
                { schoolIDs.map(schoolID => <SchoolBasket key={schoolID} schoolID={schoolID} />) }
              </List>
            </ScrollableContainer> :
            <BasketItemsIssuesModal />
          }
          { isCheckoutWindowOpen ? <CheckoutWindow schoolID={checkoutSchoolID} /> : null }
        </div>
      </Preloader>
    )
  }
  
}

export default connect(
  state => ({
    schoolIDs: getSchoolsHavingBasketItems(state),
    isValidating: isBasketItemsValidating(state),
    isValid: isBasketItemsValid(state),
    isCheckoutWindowOpen: isCheckoutWindowOpen(state),
    checkoutSchoolID: getCheckoutSchoolID(state)
  })
)(BasketPage);

class Placeholder extends React.Component {
  
  render() {
    return (
      <Card>
        <Card.Body>
          <div className="basket-school-list__placeholder">There are no items in the basket.</div>
        </Card.Body>
      </Card>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/basket/BasketPage.js